// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"dd210d89","225":"c2b44f0f","455":"327b1cc3","538":"f05889d7","570":"e71af7e7","605":"6ba1ebed","675":"086cddcd","977":"4cfb1e0c"}[chunkId] + ".chunk.js";
};